const PROFILE_LIST = {
	"PROD-RS": "prod-rs",
	DEV: "dev",
	HMG: "hmg",
};

export default PROFILE_LIST;
